<template>
    <div id="avancevideo">
    
      <v-dialog v-model="dialog1" width="600">
 
        <v-card style="border-radius:10px" class="pb-3">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn  fab flat color="#B4347E" small @click="close()">
                <v-icon x-large>cancel</v-icon>
              </v-btn>
            </v-card-actions>
                     
            <v-card-title class="headline white lighten-2 justify-center" primary-title style="color:#3492D5;font-family:Poppins!important;font-size:1.8vw;font-weight:600">
              ¡FELICIDADES! 
            </v-card-title>

            <v-card-title class="justify-center">
              <span style="color:grey;text-align:center; font-size:1.6vw;font-weight:400">Haz completado el</span>
            </v-card-title>

            <v-card-title class="justify-center">
              <img src="estrellas_dashboard.png">&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="color:#3492D5;text-align:center; font-size:5vw;font-weight:600">{{porcentaje+"%"}}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="estrellas_dashboard2.png">&nbsp;&nbsp;&nbsp;&nbsp;        
            </v-card-title>

            <v-card-title class="justify-center">
              <span style="color:grey;text-align:center; font-size:1.6vw;font-weight:400">de tu capacitación</span>
              <br>
            </v-card-title>         
            <!--<v-layout row wrap justify-center="">
        </v-layout>-->
        </v-card>
      
    </v-dialog>
    
    </div>
</template>


<script>
export default {
    data(){
        return{
            dialog:false,
            dialog1:false,
            porcentaje:''
        }
    },

    methods:{
       openAvance(){ 
            this.dialog1=true
            
        },   
        close(){
          this.dialog1=false
          //location.reload();
          this.$router.go();
        }
    }
}
</script>


<style>

</style>
